"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONShadingInfoConverter = void 0;
var shading_info_1 = require("../../shadings/shading-info");
var json_general_enums_1 = require("../enums/json-general-enums");
var json_color_model_info_converter_1 = require("./json-color-model-info-converter");
var JSONShadingInfoConverter = (function () {
    function JSONShadingInfoConverter() {
    }
    JSONShadingInfoConverter.convertFromJSON = function (obj, cache) {
        var backColor = cache.getItemByJsonKey(obj[json_general_enums_1.JSONShadingInfoProperty.BackColorIndex]);
        if (!backColor)
            backColor = json_color_model_info_converter_1.JSONColorModelInfoConverter.convertFromJSON(obj[json_general_enums_1.JSONShadingInfoProperty.BackColor]);
        var foreColor = cache.getItemByJsonKey(obj[json_general_enums_1.JSONShadingInfoProperty.ForeColorIndex]);
        if (!foreColor)
            foreColor = json_color_model_info_converter_1.JSONColorModelInfoConverter.convertFromJSON(obj[json_general_enums_1.JSONShadingInfoProperty.ForeColor]);
        return new shading_info_1.ShadingInfo(obj[json_general_enums_1.JSONShadingInfoProperty.ShadingPattern], backColor, foreColor);
    };
    JSONShadingInfoConverter.convertToJSON = function (source) {
        var result = {};
        result[json_general_enums_1.JSONShadingInfoProperty.ShadingPattern] = source.shadingPattern;
        result[json_general_enums_1.JSONShadingInfoProperty.BackColor] = json_color_model_info_converter_1.JSONColorModelInfoConverter.convertToJSON(source.backColor);
        result[json_general_enums_1.JSONShadingInfoProperty.ForeColor] = json_color_model_info_converter_1.JSONColorModelInfoConverter.convertToJSON(source.foreColor);
        return result;
    };
    return JSONShadingInfoConverter;
}());
exports.JSONShadingInfoConverter = JSONShadingInfoConverter;
